angular.module('schemaForm').config(['schemaFormProvider',
    'schemaFormDecoratorsProvider', 'sfPathProvider',
    function(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {

        // First, we want this to be the default for a combination of schema parameters
        var timepicker = function (name, schema, options) {
            if (schema.type === 'string' && schema.format == 'time') {
                // Initiate a form provider
                var f = schemaFormProvider.stdFormObj(name, schema, options);
                f.key = options.path;
                f.type = 'timepicker';
                // Add it to the lookup dict (for internal use)
                options.lookup[sfPathProvider.stringify(options.path)] = f;
                return f;

            }
        };
        // Add our default to the defaults array
        schemaFormProvider.defaults.string.unshift(timepicker);

        // Second, we want it to show if someone have explicitly set the form type
        schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'timepicker',
            'app/schema-form-component/angular-schema-form-timepicker/angular-schema-form-timepicker.html');
    }]);
